__webpack_require__.p = "/ai-discovery/_next/";